import { DEFAULT_PROJECT_MARGIN_PERCENT, ProjectUI } from "models/project"
import { useMemo } from "react"
import { EffectiveMarginTarget } from "models/project-margin-target"
import { formatCurrency, formatNumber } from "utils/tools"

interface FinancialCardProps {
    margin: number
    cost: number
    revenue: number
    date: string
    // Fiscal year margin bands (Admin > Project Margin Targets); fallback values until loaded
    marginTarget?: EffectiveMarginTarget | null
}

const WARNING_PERCENTAGE = 75


const FinancialCard = ({
    margin,
    cost,
    revenue,
    date,
    marginTarget,
}: FinancialCardProps) => {
    const costRevenueRatio = useMemo(() => (cost / revenue) * 100, [cost, revenue])

    return (
        <div className="financial-card">
            <header className="card-header">
                <div className="title">
                    <h4>FINANCIALS</h4>
                </div>
                <span className="chip">{date}</span>
            </header>

            <div className="metrics">
                <div className="metric">
                    <label>Gross Margin</label>
                    <strong className={ProjectUI.marginPercentColor(margin, marginTarget)}>{formatNumber(margin, 2)}%</strong>
                    <small>
                        {marginTarget
                            ? `Minimum ${marginTarget.minimumMargin}% · target ${marginTarget.idealMargin}% (FY${marginTarget.fiscalYear})`
                            : `Target: ${DEFAULT_PROJECT_MARGIN_PERCENT}%`}
                    </small>
                </div>
            </div>

            <div className="budget">
                <label>Budget Remaining</label>
                <div className="progress">
                    <div className={`fill-${costRevenueRatio < WARNING_PERCENTAGE ? 'success' : 'warning' }`} style={{ width: `${formatNumber(costRevenueRatio, 2)}%` }} />
                    <div className="fill-error" style={{ width: `${formatNumber(costRevenueRatio - 100, 2)}%` }} />
                </div>
                <small>{formatCurrency(cost)} / {formatCurrency(revenue)}</small>
            </div>
        </div>
    )
}

export default FinancialCard
